export const PageHead = ({ eyebrow, title, script, sub }) => (
  <section className="relative border-b border-zinc-900 overflow-hidden">
    <div className="absolute inset-0 speed-lines opacity-30" />
    <div className="absolute -left-20 top-0 w-96 h-96 bg-red-600/10 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-20 reveal">
      <p className="eyebrow mb-3">{eyebrow}</p>
      <h1 className="tms-title text-5xl sm:text-6xl lg:text-7xl">
        {title} {script && <span className="font-script normal-case text-red-500 font-bold">{script}</span>}
      </h1>
      {sub && <p className="text-zinc-400 mt-5 max-w-xl">{sub}</p>}
    </div>
  </section>
);
